var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRedo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M18.475 7.85a.935.935 0 0 0 0-1.326L14.1 2.15a.937.937 0 0 0-1.325 1.325l2.774 2.775H6.564a1 1 0 0 0-.214.024A5.626 5.626 0 0 0 6.875 17.5h2.13a.938.938 0 0 0 0-1.875h-2.13a3.751 3.751 0 0 1 0-7.5h8.674L12.775 10.9a.937.937 0 0 0 1.325 1.325z"
})));
export { SvgRedo as ReactComponent };
export default __webpack_public_path__ + "static/media/redo.b510df66.svg";